import React from 'react';

const StorefrontAppointmentHistoryControls = ({
  activeTab,
  onTabChange,
  currentCount,
  pastCount,
  filters,
  onFilterChange
}) => (
  <div className="sf-ah-controls">
    <div className="sf-ah-tabs" role="tablist" aria-label="Appointment timeframe">
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === 'current'}
        className={`sf-ah-tab${activeTab === 'current' ? ' is-active' : ''}`}
        onClick={() => onTabChange('current')}
      >
        Upcoming
        <span className="sf-ah-tab__count">{currentCount}</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === 'past'}
        className={`sf-ah-tab${activeTab === 'past' ? ' is-active' : ''}`}
        onClick={() => onTabChange('past')}
      >
        Past
        <span className="sf-ah-tab__count">{pastCount}</span>
      </button>
    </div>

    <div className="sf-ah-filters">
      <label className="sf-ah-filters__search">
        <span className="sf-ah-sr-only">Search</span>
        <input
          type="search"
          className="sf-ah-input"
          placeholder="Search by service or staff…"
          value={filters.search}
          onChange={(e) => onFilterChange('search', e.target.value)}
          autoComplete="off"
        />
      </label>
    </div>
  </div>
);

export default StorefrontAppointmentHistoryControls;
